<template lang="pug">
b-modal#getVoucherCustomMemberList(
  ref="getVoucherCustomMemberList"
  :title="$t('ui.combine.get_voucher_custom_member_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="md"
  :busy="loading"
  hide-footer=true
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      .col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="promotion_id"
            required
            type="text"
            :dirty="$v.promotion_id.$dirty"
            :error="$v.promotion_id.$error"
            v-model.trim.lazy="$v.promotion_id.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
    b-card.mb-1
      .row
        .col-sm-12.col-md-7
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)").mb-1
        .col-sm-12.col-md-5
          b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
            b-form-select(:options="$store.getters.mbLabelPageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$t('ui.member_list')" style="overflow: hidden scroll; height: 20vh;")
            div.row.animated.fadeIn
              div.col
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblListVoucher
                    thead.thead-light
                      tr
                        th.sticky-position.text-center
                          span #
                        th.sticky-position
                          span {{ $t('ui.id') }}
                    tbody
                      tr(v-if="customMemberList.length == 0")
                        td(colspan="2").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in customMemberList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
      .row
        jsonToExcel.m-auto(v-if="customMemberList.length > 0" tbl="tblListVoucher" type="1" mode="tableToExcelCustomMember" :date="dateRange" :loading="loading")
    b-card
      .row
        .col-sm-12.col-md-12
          b-form-group(:label="$t('ui.member_list')")
            b-form-textarea.col-12(
              ref="member_list"
              size="sm"
              required
              :dirty="$v.member_list.$dirty"
              :error="$v.member_list.$error"
              v-model.trim.lazy="$v.member_list.$model"
              rows="10"
              max-rows="10"
              trim=true
              :disabled="loading || delete_all "
              @paste="handlePaste"
            )
          ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")
        .col-sm-12.col-md-12
          b-form-group(
            :label="$t('ui.delete_all')"
            label-cols-sm="4"
            label-cols-lg="2"
            content-cols-sm
            content-cols-lg="7"
          )
            div.d-flex(style="padding-top:0.4rem;")
              label.custom-switch
                input.custom-switch-input(
                  type='checkbox' 
                  name='custom-switch-checkbox' 
                  required
                  :dirty="$v.delete_all.$dirty"
                  :error="$v.delete_all.$error"
                  v-model.trim.lazy="$v.delete_all.$model"
                  :disabled="loading"
                )
                span.custom-switch-indicator
      .row
        .col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
      .row
        .m-auto
          SubmitButton.mr-1(
            :loading="loading"
            icon="fa fa-minus"
            :text="$t('ui.delete')"
            type="button"
            @click="confirmDeleteCustomMember()"
            variant="danger"
            size="sm"
          )
          SubmitButton(
            :loading="loading"
            icon="fa fa-plus"
            :text="$t('ui.add')"
            type="button"
            @click="confirmAddCustomMember()"
            variant="success"
            size="sm"
          )
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    jsonToExcel
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPage: 1,
      totalRow: 0,
      sortKey: "account_id",
      sortType: "asc",
      dateRange: {
        startDate: null,
        endDate: null,
      },
      promotion_id: "",
      customMemberList: [],
      member_list: "",
      delete_all: false
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.mbLabelPageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  validations: {
    promotion_id: {
      required
    },
    member_list: {
      required: requiredIf(function () {
        return this.delete_all == false;
      })
    },
    delete_all: {
      required
    }
  },
  methods: {
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getVoucherCustomMemberList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setMbLabelPageSize", pageSize);
      this.currentPage = 1;
      this.getVoucherCustomMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getVoucherCustomMemberList();
    },
    confirmAddCustomMember() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.add_promotion_voucher_custom_member_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.addCustomMember();
          }
        });
    },
    addCustomMember: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionVoucherCustomMemberAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id,
          member_list: this.member_list
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.initial();
                  this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    confirmDeleteCustomMember() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_promotion_voucher_custom_member_confirm", { name: this.delete_all ? 'all' : 'selected' }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.deleteCustomMember();
          }
        });
    },
    deleteCustomMember: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionVoucherCustomMemberDeleteUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id,
          member_list: this.member_list,
          delete_all: this.delete_all
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.initial();
                  this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    getVoucherCustomMemberList: function(isSearch) {
      let url = config.promotionVoucherCustomMemberListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: this.promotion_id,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.customMemberList = response.data.dt;
                this.totalRow = this.customMemberList.length > 0 ? this.customMemberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    initial: function() {
      this.$v.$reset();
      this.member_list = "";
      this.delete_all = false;
      this.getVoucherCustomMemberList();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.customMemberList = [];
      this.member_list = "";
      this.promotion_id = this.item.promotion_id;
      this.getVoucherCustomMemberList();
    }
  }
};
</script>
